'use client';
import { useState, useEffect, useRef } from 'react';
import { authClient } from '@bip/api-client';
import { LoginModal } from './LoginModal';
import { IMG } from '../imgPrefix';

export function NavbarAuth() {
  // Account links use the CLEAN URLs (`/manage-bookings`, `/my-profile`, `/change-password`); the
  // next.config.js rewrites map them onto the real `/hotels/*` routes on the hotels deploy. No
  // `/hotels` prefix here (and no deploy gate) — the rewrite/edge owns the resolution.
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  const [userName, setUserName] = useState('');
  const [userInitial, setUserInitial] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // Root is a `<div>` rather than `<li>` so this component can sit
  // alongside (rather than inside) the desktop `<ul>` in the new
  // header structure. The click-outside handler ref-types follow.
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    authClient
      .getMe()
      .then((res) => {
        const loggedIn = res.message === 'success';
        setIsLoggedIn(loggedIn);
        if (loggedIn && res.data) {
          const { firstName, lastName } = res.data;
          const name = [firstName, lastName].filter(Boolean).join(' ').trim();
          setUserName(name);
          const initial = (firstName || lastName || '').charAt(0).toUpperCase();
          setUserInitial(initial);
        }
      })
      .catch(() => {
        setIsLoggedIn(false);
      });
  }, []);

  // Click-outside handler to close dropdown
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();
    await authClient.logout();
    window.location.reload();
  };

  // Show logged-in UI only after confirmed
  if (isLoggedIn === true) {
    return (
      <div className="relative" ref={wrapperRef}>
        <a
          id="navbarDropdownMenuLink-profile"
          href="#"
          className="nav-link pl-0 flex items-center"
          style={{ padding: '.5rem .5rem', lineHeight: 1 }}
          onClick={(e) => {
            e.preventDefault();
            setDropdownOpen((prev) => !prev);
          }}
        >
          {userInitial ? (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 36,
                height: 36,
                borderRadius: '50%',
                backgroundColor: '#3C0A52',
                color: '#fff',
                fontWeight: 700,
                fontSize: 16,
                flexShrink: 0,
              }}
            >
              {userInitial}
            </span>
          ) : (
            <img src={`${IMG}/image/profile-default.png`} alt="Profile" className="profileimg" />
          )}
          <span
            className="pl-2 hidden lg:inline"
            style={{ fontSize: 'var(--text-base)', whiteSpace: 'nowrap' }}
          >
            {userName ? userName.replace(/\b\w/g, (c) => c.toUpperCase()) : 'Your account'}
          </span>
        </a>
        {dropdownOpen && (
          <div className="dropdown-menu show absolute right-0 z-50 bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-48">
            <a
              href="/my-profile"
              className="dropdown-item block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <i className="fa-light fa-user pr-2"></i>
              Personal Details
            </a>
            <a
              href="/manage-bookings"
              className="dropdown-item block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <i className="fa-light fa-suitcase pr-2"></i>
              My Bookings
            </a>
            <a
              href="/change-password"
              className="dropdown-item block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <i className="fa-light fa-lock pr-2"></i>
              Change Password
            </a>
            <a
              href="#"
              className="dropdown-item block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              onClick={handleLogout}
            >
              <i className="fa-light fa-arrow-right-from-bracket pr-2"></i>
              Sign Out
            </a>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {/* <button
        className="Register-btn btn btn-primary rounded-full text-white flex items-center space-x-2 px-4 py-2"
        onClick={() => setModalOpen(true)}
      >
       
        <span className="inline-block lg:hidden">
          <i className="fa-solid fa-user"></i>
        </span>
        <span className="hidden lg:inline">Register / Sign In</span>
      </button> */}
      <button
        className="Register-btn btn btn-primary rounded-full text-white flex items-center px-4 py-2"
        onClick={() => setModalOpen(true)}
      >
        <span className="inline-block lg:hidden">
          <img draggable="true" src="/image/user.svg" width="20" alt=""></img>
        </span>
        <span className="hidden lg:inline">Register/Sign In</span>
      </button>
      <LoginModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onReopen={() => setModalOpen(true)}
      />
    </>
  );
}
